import React, { useState } from "react";
import "../Instruction/index.scss";
import titleRank from "../../../../assets/images/Event-2025/title-rank.png";
import bgTopLeft from "../../../../assets/images/Event-2025/img-top-left.png";
import bgTopRight from "../../../../assets/images/Event-2025/img-top-right.png";
import bgBotLeft from "../../../../assets/images/Event-2025/img-bot-left.png";
import bgBotRight from "../../../../assets/images/Event-2025/img-bot-right.png";
import iconTop1 from "../../../../assets/images/Event-2025/top1.svg";
import iconTop2 from "../../../../assets/images/Event-2025/top2.svg";
import iconTop3 from "../../../../assets/images/Event-2025/top3.svg";
import imgMyrank from "../../../../assets/images/Event-2025/img-myrank.png";
import { Table } from "antd";
import moment from "moment/moment";
import { isLoggedIn } from "@utils/cookie";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getRankNewYear2024 } from "dataLayer/user";
import { ID_RANK_TABLE_EVENT_2024 } from "@config/constants/helper";
import _ from "lodash";
import styled from "styled-components";

export default function RankTable() {
  const { t } = useTranslation();
  const totalTableRankLimit = 10;
  const [page, setPage] = useState(1);

  const columns = [
    {
      title: t("event_2024.rank-table.rank"),
      dataIndex: "key",
      key: "key",
      className: "number-column",
      render: (text) => {
        switch (+text + 1) {
          case 1:
            return (
              <img src={iconTop1} alt="top-1" style={{ minWidth: "38px" }} />
            );
          case 2:
            return (
              <img src={iconTop2} alt="top-2" style={{ minWidth: "38px" }} />
            );
          case 3:
            return (
              <img src={iconTop3} alt="top-3" style={{ minWidth: "38px" }} />
            );

          default:
            return <div>{text + 1}</div>;
        }
      },
    },
    {
      title: t("event_2024.rank-table.isdn"),
      dataIndex: "isdn",
      key: "isdn",
      render: (text) => <div>{text}</div>,
    },
    {
      title: t("event_2024.rank-table.number_of_matches"),
      dataIndex: "spark",
      key: "spark",
      render: (text) => <div>{text}</div>,
    },

    {
      title: t("event_2024.rank-table.number_of_firework_shells"),
      dataIndex: "shell",
      key: "shell",
      render: (text) => <div>{text}</div>,
    },

    {
      title: t("event_2024.rank-table.number_of_firework_shows"),
      dataIndex: "firework",
      key: "firework",
      render: (text) => <div>{text}</div>,
    },
    {
      title: t("event_2024.rank-table.time_of_last_firework_shows"),
      dataIndex: "paired_time",
      key: "paired_time",
      render: (_, record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        if (!_) return <div></div>;
        return (
          <div className="item-rank-timer">
            <span>{`${datePart} ${timePart}`}</span>
          </div>
        );
      },
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleTableChange = (pagination) => {
    setPage(pagination);
    scrollToTop();
  };
  const { data: dataRank = {}, isLoading } = useQuery(
    getRankNewYear2024(
      page,
      totalTableRankLimit,
      ID_RANK_TABLE_EVENT_2024.myRank
    )
  );
  const { myRank = {}, ranks = {} } = dataRank || {};
  const formatDataTable = (data = []) => {
    return data.map((item, index) => {
      const date = item?.paired_time;

      return {
        ...item,
        key:
          item?.id === myRank?.id
            ? myRank?.position - 1
            : totalTableRankLimit * (page - 1) + index,
        updated_at: {
          day: item?.paired_time ? moment(date).format("DD/MM/YYYY") : "",
          hours: item?.paired_time ? moment(date).format("HH:mm:ss") : "",
        },
      };
    });
  };
  const dataSourceMyRank = formatDataTable([myRank]);
  console.log('dataSourceMyRank: ', dataSourceMyRank);
  return (
    <Div className="event-2024-tab-rank event-2025-tab-rank">
      <div className="rank_top">
        <div className="rank_top_title">
          <img src={titleRank} alt="" />
        </div>
      </div>
      <div className="instru_rank pd_rank">
        <div className="instru_rank_content">
          <Table
            dataSource={isLoading ? [] : ranks?.data || []}
            columns={columns}
            loading={isLoading}
            pagination={
              ranks?.total > totalTableRankLimit
                ? {
                    current: page,
                    pageSize: totalTableRankLimit,
                    total: ranks?.total || 0,
                    onChange: handleTableChange,
                    showSizeChanger: false,
                    showLessItems: true,
                  }
                : false
            }
            className={`custom-table custom-table-ranking`}
          />
          {
            isLoggedIn() &&
            !_.isEmpty(dataSourceMyRank) &&
            !Number.isNaN(Number(dataSourceMyRank?.[0]?.key)) ? (

              <div
                className="my-rank-detail my-rank-detail-cus"
                style={{
                  marginTop: `${
                    dataRank?.ranks?.total < totalTableRankLimit ? "80px" : ""
                  }`,
                }}
              >
                <div className="title-my-rank">
                  <img src={imgMyrank} alt="" />
                </div>

                <Table
                  dataSource={isLoading ? [] : dataSourceMyRank || []}
                  columns={columns}
                  loading={isLoading}
                  pagination={false}
                  className="custom-table-ranking table_myrank"
                  rowClassName="my-rank-active"
                />
              </div>

            ) : null
          }

        </div>
        <div className="bg_top_left">
          <img src={bgTopLeft} alt="" />
        </div>
        <div className="bg_top_right">
          <img src={bgTopRight} alt="" />
        </div>
      </div>
      <div className="bg_bot_left">
        <img src={bgBotLeft} alt="" />
      </div>
      <div className="bg_bot_right">
        <img src={bgBotRight} alt="" />
      </div>
    </Div>
  );
}

const Div = styled.div`
  .instru_rank_content .custom-table-ranking th {
    border-bottom: 1px solid #eadcd1;
    font-weight: 500;
    color: #57534e;
    padding-bottom: 5px;
  }
  .ant-table {
    background: unset !important;
  }
  .ant-table tr td div {
    /* color: #292524 !important; */
  }
  .ant-table tr th {
    background: unset !important;
    color: #292524 !important;
  }

  .pd_rank {
    padding-top: 20px !important;
    min-height: 900px !important;
  }

  @media (max-width: 1500px) {
    .pd_rank {
      padding-top: 20px !important;
      min-height: 1150px !important;
    }

    .table_myrank tr td div,
    .table_myrank tr td div span {
      font-size: 14px;
    }

    .instru_rank_content .my-rank-detail tr td:first-child{
      border-radius: 34px 0 0 34px;
    }
  }
`;
